// Copyright 2019-present BAIKAL AI Inc.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file bareun/language_service.proto (package bareun, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Document, EncodingType, TextSpan } from "./lang_common_pb";
import { file_bareun_lang_common } from "./lang_common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bareun/language_service.proto.
 */
export const file_bareun_language_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bareun_lang_common]);

/**
 * ################################################################ #
 * 입력 문서에 분석된 문장
 *
 * @generated from message bareun.Sentence
 */
export type Sentence = Message<"bareun.Sentence"> & {
  /**
   * The sentence text.
   *
   * @generated from field: bareun.TextSpan text = 1;
   */
  text?: TextSpan | undefined;

  /**
   * 어절단위로 쪼개는 것은
   *
   * @generated from field: repeated bareun.Token tokens = 2;
   */
  tokens: Token[];

  /**
   * 띄어쓰기 등의 오류를 수정한 결과물
   *
   * @generated from field: string refined = 3;
   */
  refined: string;
};

/**
 * Describes the message bareun.Sentence.
 * Use `create(SentenceSchema)` to create a new message.
 */
export const SentenceSchema: GenMessage<Sentence> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 0);

/**
 * WSD(동형이의어 의미 구분) 결과 하나. Morpheme.sense 로 실린다.
 *
 * # 왜 별도 메시지인가 (#1851)
 *
 * 예전엔 sense_str/sense_meaning/sense_urimal_no 를 Morpheme 에 평평하게 늘어놓았는데, 세 가지가
 * 곤란했다:
 *
 *   1. sense 는 **일부 형태소에만** 붙는다(조사·어미엔 원래 없고, with_sense=false 면 전부 없다).
 *      평평한 스칼라 필드는 proto3 기본이 암묵적 존재라 값이 없어도 빈 문자열로 응답에 실려,
 *      WSD 를 쓰지 않는 호출에까지 의미 없는 필드가 형태소마다 붙었다.
 *   2. "sense 가 있다/없다"를 클라이언트가 판정하려면 어느 필드를 봐야 하는지 애매했다
 *      (sense_str 은 있는데 뜻풀이가 없는 조합이 실제로 존재한다).
 *   3. 필드가 늘 때마다 Morpheme 이 넓어졌다.
 *
 * 메시지로 묶으면 셋 다 풀린다 — 메시지 필드는 proto3 에서도 명시적 존재라 미부여면 **필드 자체가
 * 없고**, `sense` 유무 하나로 판정이 끝나며, 확장은 이 메시지 안에서 한다.
 *
 * @generated from message bareun.Sense
 */
export type Sense = Message<"bareun.Sense"> & {
  /**
   * 어깨번호. 같은 표제어의 동형이의어를 가르는 우리말샘 의미 번호다 (예: 1, 2, 7).
   *
   * 말뭉치·sense 어휘의 표기는 3자리 0채움 문자열("001")이지만 여기서는 **수치**로 준다 —
   * 클라이언트가 비교·정렬할 때 문자열이면 매번 파싱해야 하기 때문이다. 원래 표기가 필요하면
   * 3자리 0채움으로 되돌리면 된다(예: 1 → "001").
   *
   * 우리말샘 3자리 체계다(#1834 라벨 공간 전환). 세종 2자리 표기가 섞여 들어오면 학습 sense
   * 어휘에 구 라벨 공간이 남은 것이므로 결함으로 취급한다.
   *
   * 표제어와 품사는 이 메시지에 넣지 않는다 — 표제어는 Token.lemma, 품사는 Morpheme.tag 로
   * 이미 나가므로 중복이다.
   *
   * @generated from field: uint32 sense_no = 1;
   */
  senseNo: number;

  /**
   * 한국어 뜻풀이 (예: "사람이나 짐 따위를 싣고 물 위로 떠다니도록 ... 만든 물건.").
   *
   * 빈 값일 수 있다 — 우리말샘 조인 매칭률이 100% 가 아니다(실측 99.4%). sense 가 붙었다고 해서
   * 뜻풀이가 있다고 가정하지 말 것.
   *
   * @generated from field: string meaning = 2;
   */
  meaning: string;

  /**
   * 우리말샘 표제어 고유 번호(target_code). 서비스 개편 이후에도 불변이다. 예: 167957.
   * URL 재조립: http://opendict.korean.go.kr/dictionary/view?sense_no={urimal_target_id}
   *
   * 원본 사전(dict.fbs 의 OpenDictWord.id)이 int32 라 여기서도 수치로 맞춘다.
   * meaning 과 마찬가지로 0(미부여)일 수 있다.
   *
   * @generated from field: int32 urimal_target_id = 3;
   */
  urimalTargetId: number;

  /**
   * 이 의미를 고른 확률 [0, 1].
   *
   * **후보 집합 안에서의 softmax** 다 — 전체 sense 클래스(약 58,000개)가 아니라, 그 (표제어, 품사)
   * 의 후보 의미들만 놓고 정규화한 값이다. 서빙이 후보 집합 안에서 argmax 를 취하도록 학습·평가
   * 됐으므로(전체 클래스 argmax 는 사실상 무작위), 실제 결정이 일어난 공간에서의 확률이라야 뜻이
   * 있기 때문이다.
   *
   * 주의: 후보가 하나뿐인 표제어는 항상 1.0 이다. 이는 "확신"이 아니라 "고를 것이 하나뿐"이라는
   * 뜻이므로, 신뢰도 임계값으로 쓸 때는 후보 수를 함께 고려해야 한다.
   *
   * ⚠️ **Morpheme.probability 와 이름은 같지만 성질이 다르다.** 그쪽은 클래스별 **독립 시그모이드**
   * 값이라 한 위치의 값들을 더해도 1 이 아니다(실측 1.50~1.57). 이쪽만 후보 집합 softmax 라
   * 합이 1 인 진짜 확률분포다. 두 값을 같은 임계값으로 비교하거나 한 축에 함께 그리지 말 것.
   *
   * @generated from field: float probability = 6;
   */
  probability: number;
};

/**
 * Describes the message bareun.Sense.
 * Use `create(SenseSchema)` to create a new message.
 */
export const SenseSchema: GenMessage<Sense> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 1);

/**
 * 형태소
 *
 * @generated from message bareun.Morpheme
 */
export type Morpheme = Message<"bareun.Morpheme"> & {
  /**
   * The sentence text.
   *
   * @generated from field: bareun.TextSpan text = 1;
   */
  text?: TextSpan | undefined;

  /**
   * 형태소 태그
   *
   * @generated from field: bareun.Morpheme.Tag tag = 2;
   */
  tag: Morpheme_Tag;

  /**
   * 이 태그에 대한 모델 점수 [0, 1]. 값이 클수록 그 품사일 가능성이 높다.
   *
   * ⚠️ **확률분포가 아니다.** tag-model 의 출력단은 softmax 가 아니라 **클래스별 독립 시그모이드**라
   * (ONNX 그래프의 마지막 연산이 Sigmoid — 안쪽 Softmax 2개는 어텐션 가중치다), 한 위치의 49개
   * 클래스 값을 더해도 1 이 되지 않는다(실측 1.50~1.57). 따라서
   *   - 다른 후보 태그의 값과 더하거나 "나머지 확률" 을 계산하지 말 것.
   *   - Sense.probability(후보 집합 softmax, 합=1)와 **척도가 다르므로** 같은 임계값으로 비교하거나
   *     한 축에 함께 그리지 말 것.
   *
   * 이름이 probability 인 것은 초기 API 부터 굳은 것이라 유지한다(개명은 JSON 키를 바꿔 기존
   * 클라이언트를 깨뜨린다). 성질을 정확히 부르자면 score 나 confidence 다.
   *
   * @generated from field: float probability = 3;
   */
  probability: number;

  /**
   * 사전에 없는 단어 표시
   *
   * @generated from field: bareun.Morpheme.OutOfVocab out_of_vocab = 5;
   */
  outOfVocab: Morpheme_OutOfVocab;

  /**
   * 사용된 사용자 사전의 이름
   *
   * @generated from field: optional string custom_dict_name = 6;
   */
  customDictName?: string | undefined;

  /**
   * WSD(동형이의어 의미 구분) 결과. tag-sense-model.onnx + sense-vocab.fb 가 로드되고
   * 요청이 with_sense=true 이며, 이 형태소에 의미가 부여된 경우에만 실린다.
   *
   * **필드 없음 = 미부여.** 조사·어미처럼 의미를 갖지 않는 형태소에는 원래 붙지 않는다.
   *
   * # 왜 optional 인가 (메시지 필드인데도)
   *
   * 일반적인 proto3 라면 메시지 필드는 이미 명시적 존재라 optional 이 무의미하다. 그런데 이 서버의
   * JSON 코덱은 **EmitUnpopulated: true** 로 설정돼 있어(jsoncodec.go — 클라이언트가 0값 필드를
   * 기대하도록 오래 굳은 계약이다), 미설정 메시지 필드를 `"sense": null` 로 내보낸다.
   *
   * protojson 은 EmitUnpopulated 여도 **합성 oneof 는 생략**하는데, proto3 의 optional 이 바로 그
   * 합성 oneof 다. 그래서 여기서는 optional 이 "키를 아예 빼는" 유일한 수단이다(실측 확인:
   * jsoncodec_test.go 의 TestSenseOmittedWhenUnset). 같은 이유로 custom_dict_name 도 optional 이다.
   *
   * @generated from field: optional bareun.Sense sense = 7;
   */
  sense?: Sense | undefined;
};

/**
 * Describes the message bareun.Morpheme.
 * Use `create(MorphemeSchema)` to create a new message.
 */
export const MorphemeSchema: GenMessage<Morpheme> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 2);

/**
 * 사전에 없는 단어 정보 처리 결과
 *
 * @generated from enum bareun.Morpheme.OutOfVocab
 */
export enum Morpheme_OutOfVocab {
  /**
   * 워드 임베딩에 포함된 내용
   *
   * @generated from enum value: IN_WORD_EMBEDDING = 0;
   */
  IN_WORD_EMBEDDING = 0,

  /**
   * 자동 추측, 미등록 단어
   *
   * @generated from enum value: OUT_OF_VOCAB = 1;
   */
  OUT_OF_VOCAB = 1,

  /**
   * 사용자 제공 사전에 있는 내용
   *
   * @generated from enum value: IN_CUSTOM_DICT = 2;
   */
  IN_CUSTOM_DICT = 2,

  /**
   * 기본 사전에 포함된 내용
   *
   * @generated from enum value: IN_BUILTIN_DICT = 3;
   */
  IN_BUILTIN_DICT = 3,

  /**
   * 우리말샘에 포함된 내용
   *
   * @generated from enum value: IN_URIMALSAEM = 4;
   */
  IN_URIMALSAEM = 4,

  /**
   * 위키 백과 사전에 포함된 내용
   *
   * @generated from enum value: IN_WIKI_DICT = 5;
   */
  IN_WIKI_DICT = 5,

  /**
   * 온 용어 사전에 포함된 내용
   *
   * @generated from enum value: IN_ON_DICT = 6;
   */
  IN_ON_DICT = 6,
}

/**
 * Describes the enum bareun.Morpheme.OutOfVocab.
 */
export const Morpheme_OutOfVocabSchema: GenEnum<Morpheme_OutOfVocab> = /*@__PURE__*/
  enumDesc(file_bareun_language_service, 2, 0);

/**
 * 내부적으로 pred 된 형태소는 0~46까지 반환하지만,
 * 1~47까지 숫자로 쓰고, UNK은 0으로 바꾼다.
 *
 * @generated from enum bareun.Morpheme.Tag
 */
export enum Morpheme_Tag {
  /**
   * // 0 1 EC
   * // 1 2 EF
   * // 2 3 EP
   * // 3 4 ETM
   * // 4 5 ETN
   * // 5 6 IC
   * // 6 7 JC
   * // 7 8 JKB
   * // 8 9 JKC
   * // 9 10 JKG
   * // 10 11 JKO
   * // 11 12 JKQ
   * // 12 13 JKS
   * // 13 14 JKV
   * // 14 15 JX
   * // 15 16 MAG
   * // 16 17 MAJ
   * // 17 18 MMA
   * // 18 19 MMD
   * // 19 20 MMN
   * // 20 21 NA
   * // 21 22 NF
   * // 22 23 NNB
   * // 23 24 NNG
   * // 24 25 NNP
   * // 25 26 NP
   * // 26 27 NR
   * // 27 28 NV
   * // 28 29 SE
   * // 29 30 SF
   * // 30 31 SH
   * // 31 32 SL
   * // 32 33 SN
   * // 33 34 SO
   * // 34 35 SP
   * // 35 36 SS
   * // 36 37 SW
   * // 37 38 VA
   * // 38 39 VCN
   * // 39 40 VCP
   * // 40 41 VV
   * // 41 42 VX
   * // 42 43 XPN
   * // 43 44 XR
   * // 44 45 XSA
   * // 45 46 XSN
   * // 46 47 XSV
   *
   * @generated from enum value: UNK = 0;
   */
  UNK = 0,

  /**
   * 일반 명사
   *
   * @generated from enum value: NNG = 24;
   */
  NNG = 24,

  /**
   * 고유 명사
   *
   * @generated from enum value: NNP = 25;
   */
  NNP = 25,

  /**
   * 의존 명사
   *
   * @generated from enum value: NNB = 23;
   */
  NNB = 23,

  /**
   * 대명사
   *
   * @generated from enum value: NP = 26;
   */
  NP = 26,

  /**
   * 수사
   *
   * @generated from enum value: NR = 27;
   */
  NR = 27,

  /**
   * 명사 추정 범주
   *
   * @generated from enum value: NF = 22;
   */
  NF = 22,

  /**
   * 분석불능범주
   *
   * @generated from enum value: NA = 21;
   */
  NA = 21,

  /**
   * 용언 추정 범주
   *
   * @generated from enum value: NV = 28;
   */
  NV = 28,

  /**
   * 동사
   *
   * @generated from enum value: VV = 41;
   */
  VV = 41,

  /**
   * 형용사
   *
   * @generated from enum value: VA = 38;
   */
  VA = 38,

  /**
   * 보조 용언
   *
   * @generated from enum value: VX = 42;
   */
  VX = 42,

  /**
   * 긍정 지정사
   *
   * @generated from enum value: VCP = 40;
   */
  VCP = 40,

  /**
   * 부정 지정사
   *
   * @generated from enum value: VCN = 39;
   */
  VCN = 39,

  /**
   * 성상 관형사
   *
   * @generated from enum value: MMA = 18;
   */
  MMA = 18,

  /**
   * 지시 관형사
   *
   * @generated from enum value: MMD = 19;
   */
  MMD = 19,

  /**
   * 수 관형사
   *
   * @generated from enum value: MMN = 20;
   */
  MMN = 20,

  /**
   * 일반 부사
   *
   * @generated from enum value: MAG = 16;
   */
  MAG = 16,

  /**
   * 접속 부사
   *
   * @generated from enum value: MAJ = 17;
   */
  MAJ = 17,

  /**
   * 감탄사
   *
   * @generated from enum value: IC = 6;
   */
  IC = 6,

  /**
   * 주격 조사
   *
   * @generated from enum value: JKS = 13;
   */
  JKS = 13,

  /**
   * 보격 조사
   *
   * @generated from enum value: JKC = 9;
   */
  JKC = 9,

  /**
   * 관형격 조사
   *
   * @generated from enum value: JKG = 10;
   */
  JKG = 10,

  /**
   * 목적격 조사
   *
   * @generated from enum value: JKO = 11;
   */
  JKO = 11,

  /**
   * 부사격 조사
   *
   * @generated from enum value: JKB = 8;
   */
  JKB = 8,

  /**
   * 호격 조사
   *
   * @generated from enum value: JKV = 14;
   */
  JKV = 14,

  /**
   * 인용격 조사
   *
   * @generated from enum value: JKQ = 12;
   */
  JKQ = 12,

  /**
   * 보조사
   *
   * @generated from enum value: JX = 15;
   */
  JX = 15,

  /**
   * 접속 조사
   *
   * @generated from enum value: JC = 7;
   */
  JC = 7,

  /**
   * 선어말 어미
   *
   * @generated from enum value: EP = 3;
   */
  EP = 3,

  /**
   * 종결 어미
   *
   * @generated from enum value: EF = 2;
   */
  EF = 2,

  /**
   * 연결 어미
   *
   * @generated from enum value: EC = 1;
   */
  EC = 1,

  /**
   * 명사형 전성 어미
   *
   * @generated from enum value: ETN = 5;
   */
  ETN = 5,

  /**
   * 관형형 전성 어미
   *
   * @generated from enum value: ETM = 4;
   */
  ETM = 4,

  /**
   * 체언 접두사
   *
   * @generated from enum value: XPN = 43;
   */
  XPN = 43,

  /**
   * 명사 파생 접미사
   *
   * @generated from enum value: XSN = 46;
   */
  XSN = 46,

  /**
   * 동사 파생 접미사
   *
   * @generated from enum value: XSV = 47;
   */
  XSV = 47,

  /**
   * 형용사 파생 접미사
   *
   * @generated from enum value: XSA = 45;
   */
  XSA = 45,

  /**
   * 어근
   *
   * @generated from enum value: XR = 44;
   */
  XR = 44,

  /**
   * 마침표,물음표,느낌표
   *
   * @generated from enum value: SF = 30;
   */
  SF = 30,

  /**
   * 쉼표,가운뎃점,콜론,빗금
   *
   * @generated from enum value: SP = 35;
   */
  SP = 35,

  /**
   * 따옴표,괄호표,줄표
   *
   * @generated from enum value: SS = 36;
   */
  SS = 36,

  /**
   * 줄임표
   *
   * @generated from enum value: SE = 29;
   */
  SE = 29,

  /**
   * 붙임표(물결,숨김,빠짐)
   *
   * @generated from enum value: SO = 34;
   */
  SO = 34,

  /**
   * 기타기호 (논리수학기호,화폐기호)
   *
   * @generated from enum value: SW = 37;
   */
  SW = 37,

  /**
   * 외국어
   *
   * @generated from enum value: SL = 32;
   */
  SL = 32,

  /**
   * 한자
   *
   * @generated from enum value: SH = 31;
   */
  SH = 31,

  /**
   * 숫자
   *
   * @generated from enum value: SN = 33;
   */
  SN = 33,
}

/**
 * Describes the enum bareun.Morpheme.Tag.
 */
export const Morpheme_TagSchema: GenEnum<Morpheme_Tag> = /*@__PURE__*/
  enumDesc(file_bareun_language_service, 2, 1);

/**
 * 어절
 *
 * @generated from message bareun.Token
 */
export type Token = Message<"bareun.Token"> & {
  /**
   * The token text.
   *
   * @generated from field: bareun.TextSpan text = 1;
   */
  text?: TextSpan | undefined;

  /**
   * 어절 내부의 형태소 분리
   *
   * @generated from field: repeated bareun.Morpheme morphemes = 2;
   */
  morphemes: Morpheme[];

  /**
   * 원형
   * [Lemma](https://en.wikipedia.org/wiki/Lemma_%28morphology%29) of the token.
   *
   * @generated from field: string lemma = 4;
   */
  lemma: string;

  /**
   * 테그 문자열
   *
   * @generated from field: string tagged = 5;
   */
  tagged: string;

  /**
   * 원래의 값과 다른 내용이 있으면 modified에 값을 넣는다.
   *
   * @generated from field: string modified = 11;
   */
  modified: string;
};

/**
 * Describes the message bareun.Token.
 * Use `create(TokenSchema)` to create a new message.
 */
export const TokenSchema: GenMessage<Token> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 3);

/**
 * 형태소 분석 요청 메시지
 *
 * @generated from message bareun.AnalyzeSyntaxRequest
 */
export type AnalyzeSyntaxRequest = Message<"bareun.AnalyzeSyntaxRequest"> & {
  /**
   * 입력 문서
   *
   * @generated from field: bareun.Document document = 1;
   */
  document?: Document | undefined;

  /**
   * 오프셋을 계산하기 위한 인코딩 타입
   *
   * @generated from field: bareun.EncodingType encoding_type = 2;
   */
  encodingType: EncodingType;

  /**
   * auto split sentence true이면 자동으로 문장 분리를 시도한다.
   * 없으면 NEWLINE을 기준으로 문장을 자른다.
   * 기본값은 false 이다.
   *
   * @generated from field: bool auto_split_sentence = 3;
   */
  autoSplitSentence: boolean;

  /**
   * 커스텀 사전 도메인 정보
   * v4.0에서는 폐기될 예정입니다. 새로운 custom_dict_names를 사용해주세요.
   * 새로운 custom_dict_names에 값이 들어있는 경우, 이 값은 무시됩니다.
   *
   * @generated from field: string custom_domain = 4 [deprecated = true];
   * @deprecated
   */
  customDomain: string;

  /**
   * 자동 띄어쓰기
   *
   * @generated from field: bool auto_spacing = 5;
   */
  autoSpacing: boolean;

  /**
   * 자동 붙여쓰기
   *
   * @generated from field: bool auto_jointing = 6;
   */
  autoJointing: boolean;

  /**
   * WSD(동형이의어 의미 구분) 결과 포함 여부. 기본값 false.
   * true 이고 서버에 tag-sense-model.onnx 가 로드된 경우에만, 응답 Morpheme 에
   * sense(Sense 메시지, 필드 10)가 실린다(추가 추론 1회 비용).
   * false 면 기존 tag-model 단일 추론 경로 그대로다(비용·결과 불변) — 이때 sense 는 아예 없다.
   *
   * @generated from field: bool with_sense = 7;
   */
  withSense: boolean;

  /**
   * 커스텀 사전 이름들
   * CustomDictionaryService를 사용해서 만든 사전을 여러 개 지정한다.
   * 하나 이상의 지정할 경우, 먼저 나오는 사전이 우선되어 사용된다.
   *
   * @generated from field: repeated string custom_dict_names = 11;
   */
  customDictNames: string[];
};

/**
 * Describes the message bareun.AnalyzeSyntaxRequest.
 * Use `create(AnalyzeSyntaxRequestSchema)` to create a new message.
 */
export const AnalyzeSyntaxRequestSchema: GenMessage<AnalyzeSyntaxRequest> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 4);

/**
 * 형태 분석 응답 메시지
 *
 * @generated from message bareun.AnalyzeSyntaxResponse
 */
export type AnalyzeSyntaxResponse = Message<"bareun.AnalyzeSyntaxResponse"> & {
  /**
   * 입력된 문장에 포함된 문장들
   *
   * @generated from field: repeated bareun.Sentence sentences = 1;
   */
  sentences: Sentence[];

  /**
   * 텍스트의 언어, 만일 언어가 지정되지 않은 경우에는 자동으로 탐지하여 반환한다.
   * 언어가 지정된 경우에는 동일한 언어를 반환한다.
   * 이때, 언어는 ko_KR 등과 같이 사용한다.
   *
   * @generated from field: string language = 3;
   */
  language: string;

  /**
   * 어절의 개수
   *
   * @generated from field: int32 tokens_count = 100;
   */
  tokensCount: number;
};

/**
 * Describes the message bareun.AnalyzeSyntaxResponse.
 * Use `create(AnalyzeSyntaxResponseSchema)` to create a new message.
 */
export const AnalyzeSyntaxResponseSchema: GenMessage<AnalyzeSyntaxResponse> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 5);

/**
 * 후처리 없는 순수 형태소 분석 요청 메시지.
 * seg_model + tag_model 추론만 수행하며 복합명사·복합동사 분해,
 * 자동 띄어쓰기·붙여쓰기를 일절 적용하지 않는다.
 * 사용자 사전도 적용하지 않는다(순수 모델 출력 보장).
 * 응답 형식은 AnalyzeSyntaxResponse와 동일하다.
 *
 * @generated from message bareun.AnalyzeSyntaxRawRequest
 */
export type AnalyzeSyntaxRawRequest = Message<"bareun.AnalyzeSyntaxRawRequest"> & {
  /**
   * 입력 문서
   *
   * @generated from field: bareun.Document document = 1;
   */
  document?: Document | undefined;

  /**
   * 오프셋을 계산하기 위한 인코딩 타입
   *
   * @generated from field: bareun.EncodingType encoding_type = 2;
   */
  encodingType: EncodingType;

  /**
   * auto split sentence true이면 자동으로 문장 분리를 시도한다.
   * 없으면 NEWLINE을 기준으로 문장을 자른다.
   * 기본값은 false 이다.
   *
   * @generated from field: bool auto_split_sentence = 3;
   */
  autoSplitSentence: boolean;

  /**
   * WSD(동형이의어 의미 구분) 결과 포함 여부. 기본값 false.
   * raw 응답에도 후처리 없는 모델 sense 출력을 그대로 싣는다(WSD 개발·평가용).
   * AnalyzeSyntaxRequest.with_sense 와 동일한 의미·비용 특성이다.
   *
   * @generated from field: bool with_sense = 4;
   */
  withSense: boolean;
};

/**
 * Describes the message bareun.AnalyzeSyntaxRawRequest.
 * Use `create(AnalyzeSyntaxRawRequestSchema)` to create a new message.
 */
export const AnalyzeSyntaxRawRequestSchema: GenMessage<AnalyzeSyntaxRawRequest> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 6);

/**
 * 형태소 분석 요청 메시지
 *
 * @generated from message bareun.AnalyzeSyntaxListRequest
 */
export type AnalyzeSyntaxListRequest = Message<"bareun.AnalyzeSyntaxListRequest"> & {
  /**
   * 입력 문장의 배열
   *
   * @generated from field: repeated string sentences = 1;
   */
  sentences: string[];

  /**
   * 입력 문장의 언어
   *
   * @generated from field: string language = 2;
   */
  language: string;

  /**
   * 오프셋을 계산하기 위한 인코딩 타입
   *
   * @generated from field: bareun.EncodingType encoding_type = 3;
   */
  encodingType: EncodingType;

  /**
   * 커스텀 사전 도메인 정보
   * v4.0에서는 폐기될 예정입니다. 새로운 custom_dict_names를 사용해주세요.
   * 새로운 custom_dict_names에 값이 들어있는 경우, 이 값은 무시됩니다.
   *
   * @generated from field: string custom_domain = 4 [deprecated = true];
   * @deprecated
   */
  customDomain: string;

  /**
   * 자동 띄어쓰기
   *
   * @generated from field: bool auto_spacing = 5;
   */
  autoSpacing: boolean;

  /**
   * 자동 붙여쓰기
   *
   * @generated from field: bool auto_jointing = 6;
   */
  autoJointing: boolean;

  /**
   * WSD(동형이의어 의미 구분) 결과 포함 여부. 기본값 false.
   * AnalyzeSyntaxRequest.with_sense 와 동일한 의미·비용 특성이다.
   *
   * @generated from field: bool with_sense = 7;
   */
  withSense: boolean;

  /**
   * 커스텀 사전 이름들
   * CustomDictionaryService를 사용해서 만든 사전을 여러 개 지정한다.
   * 하나 이상의 지정할 경우, 먼저 나오는 사전이 우선되어 사용된다.
   *
   * @generated from field: repeated string custom_dict_names = 11;
   */
  customDictNames: string[];
};

/**
 * Describes the message bareun.AnalyzeSyntaxListRequest.
 * Use `create(AnalyzeSyntaxListRequestSchema)` to create a new message.
 */
export const AnalyzeSyntaxListRequestSchema: GenMessage<AnalyzeSyntaxListRequest> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 7);

/**
 * 형태 분석 응답 메시지
 *
 * @generated from message bareun.AnalyzeSyntaxListResponse
 */
export type AnalyzeSyntaxListResponse = Message<"bareun.AnalyzeSyntaxListResponse"> & {
  /**
   * 입력된 문장에 포함된 문장들
   * 여기서 문장은 요청에 대응하여 1:1로 맞춰진다.
   * 만일 요청이 빈 문장이면 빈 문장으로 대응한다.
   *
   * @generated from field: repeated bareun.Sentence sentences = 1;
   */
  sentences: Sentence[];

  /**
   * 텍스트의 언어, 만일 언어가 지정되지 않은 경우에는 자동으로 탐지하여 반환한다.
   * 언어가 지정된 경우에는 동일한 언어를 반환한다.
   * 이때, 언어는 ko_KR 등과 같이 사용한다.
   *
   * @generated from field: string language = 3;
   */
  language: string;

  /**
   * 어절의 개수
   *
   * @generated from field: int32 tokens_count = 100;
   */
  tokensCount: number;
};

/**
 * Describes the message bareun.AnalyzeSyntaxListResponse.
 * Use `create(AnalyzeSyntaxListResponseSchema)` to create a new message.
 */
export const AnalyzeSyntaxListResponseSchema: GenMessage<AnalyzeSyntaxListResponse> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 8);

/**
 * 토크나이즈 요청 메시지
 *
 * @generated from message bareun.TokenizeRequest
 */
export type TokenizeRequest = Message<"bareun.TokenizeRequest"> & {
  /**
   * Input document.
   *
   * @generated from field: bareun.Document document = 1;
   */
  document?: Document | undefined;

  /**
   * The encoding type used by the API to calculate offsets.
   *
   * @generated from field: bareun.EncodingType encoding_type = 2;
   */
  encodingType: EncodingType;

  /**
   * auto split sentence 옵션은 사용하지 않는다.
   * 기본적으로 '\n' 을 기준으로 문장을 자른다.
   * 기본값은 false 이다.
   *
   * @generated from field: bool auto_split_sentence = 3 [deprecated = true];
   * @deprecated
   */
  autoSplitSentence: boolean;

  /**
   * 자동 띄어쓰기
   *
   * @generated from field: bool auto_spacing = 5;
   */
  autoSpacing: boolean;
};

/**
 * Describes the message bareun.TokenizeRequest.
 * Use `create(TokenizeRequestSchema)` to create a new message.
 */
export const TokenizeRequestSchema: GenMessage<TokenizeRequest> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 9);

/**
 * 토큰의 분절된 내용
 *
 * @generated from message bareun.Segment
 */
export type Segment = Message<"bareun.Segment"> & {
  /**
   * The token text.
   *
   * @generated from field: bareun.TextSpan text = 1;
   */
  text?: TextSpan | undefined;

  /**
   * 각 위치에 대한 정보
   *
   * @generated from field: string hint = 2;
   */
  hint: string;
};

/**
 * Describes the message bareun.Segment.
 * Use `create(SegmentSchema)` to create a new message.
 */
export const SegmentSchema: GenMessage<Segment> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 10);

/**
 * @generated from message bareun.SegmentToken
 */
export type SegmentToken = Message<"bareun.SegmentToken"> & {
  /**
   * The token text.
   *
   * @generated from field: bareun.TextSpan text = 1;
   */
  text?: TextSpan | undefined;

  /**
   * 어절 내부의 형태소 분리
   *
   * @generated from field: repeated bareun.Segment segments = 2;
   */
  segments: Segment[];

  /**
   * 아름답/V+ㄴ/E
   *
   * @generated from field: string tagged = 5;
   */
  tagged: string;
};

/**
 * Describes the message bareun.SegmentToken.
 * Use `create(SegmentTokenSchema)` to create a new message.
 */
export const SegmentTokenSchema: GenMessage<SegmentToken> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 11);

/**
 * @generated from message bareun.SegmentSentence
 */
export type SegmentSentence = Message<"bareun.SegmentSentence"> & {
  /**
   * The token text.
   *
   * @generated from field: bareun.TextSpan text = 1;
   */
  text?: TextSpan | undefined;

  /**
   * 어절 내부의 형태소 분리
   *
   * @generated from field: repeated bareun.SegmentToken tokens = 2;
   */
  tokens: SegmentToken[];
};

/**
 * Describes the message bareun.SegmentSentence.
 * Use `create(SegmentSentenceSchema)` to create a new message.
 */
export const SegmentSentenceSchema: GenMessage<SegmentSentence> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 12);

/**
 * Tokenize 요청 토크나이즈에 대한 요청
 *
 * @generated from message bareun.TokenizeResponse
 */
export type TokenizeResponse = Message<"bareun.TokenizeResponse"> & {
  /**
   * 분절 분리된 문장들의 배열
   *
   * @generated from field: repeated bareun.SegmentSentence sentences = 1;
   */
  sentences: SegmentSentence[];

  /**
   * ISO 문자 코드
   *
   * @generated from field: string language = 3;
   */
  language: string;

  /**
   * 어절의 개수
   *
   * @generated from field: int32 tokens_count = 100;
   */
  tokensCount: number;
};

/**
 * Describes the message bareun.TokenizeResponse.
 * Use `create(TokenizeResponseSchema)` to create a new message.
 */
export const TokenizeResponseSchema: GenMessage<TokenizeResponse> = /*@__PURE__*/
  messageDesc(file_bareun_language_service, 13);

/**
 * 한국어에 대한 분석 서비스를 제공하는 서비스.
 *
 * @generated from service bareun.LanguageService
 */
export const LanguageService: GenService<{
  /**
   * 텍스트의 형태를 분석하고, 문장 경계를 파악하여 토큰 단위로 잘라낸다.
   *
   * @generated from rpc bareun.LanguageService.AnalyzeSyntax
   */
  analyzeSyntax: {
    methodKind: "unary";
    input: typeof AnalyzeSyntaxRequestSchema;
    output: typeof AnalyzeSyntaxResponseSchema;
  },
  /**
   * 복수의 문장을 대상으로 텍스트의 형태를 분석하고, 토큰 단위로 잘라낸다.
   * 복수의 문장에 대한 순서를 그대로 반환하고 문장을 분할하지 않는다.
   *
   * @generated from rpc bareun.LanguageService.AnalyzeSyntaxList
   */
  analyzeSyntaxList: {
    methodKind: "unary";
    input: typeof AnalyzeSyntaxListRequestSchema;
    output: typeof AnalyzeSyntaxListResponseSchema;
  },
  /**
   * seg_model + tag_model 추론 결과를 후처리 없이 그대로 반환한다.
   * 복합명사·복합동사 분해, 자동 띄어쓰기·붙여쓰기를 적용하지 않는다.
   * 순수 모델 성능 평가, BigKinds 재태깅, WSD 개발 등 후처리 개입 없는
   * 원시(raw) 분석 결과가 필요한 경우에 사용한다.
   * 응답 형식은 AnalyzeSyntaxResponse와 동일하다.
   *
   * @generated from rpc bareun.LanguageService.AnalyzeSyntaxRaw
   */
  analyzeSyntaxRaw: {
    methodKind: "unary";
    input: typeof AnalyzeSyntaxRawRequestSchema;
    output: typeof AnalyzeSyntaxResponseSchema;
  },
  /**
   * 한국어의 특성에 따라서 텍스트를 분절 단뤼로 구분해 낸다.
   *
   * @generated from rpc bareun.LanguageService.Tokenize
   */
  tokenize: {
    methodKind: "unary";
    input: typeof TokenizeRequestSchema;
    output: typeof TokenizeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bareun_language_service, 0);

